export function toRouter(menus, packageName) {
  for (let i = 0; i < menus.length; i++) {
    const menu = menus[i]
    if (!menu.component) {
      // menu.component = resolve => require([`@/views/layout/Layout`], resolve)
      menu.component = () => Promise.resolve(require('@/layout'))
    } else {
      const path = menu.component
      if (packageName) {
        menu.component = () => Promise.resolve(require(`@/views/${packageName}/${path}/index`))
        // menu.component = () => import('@/views/sys/menu/index')
      } else {
        menu.component = () => Promise.resolve(require('@/views/' + path + '/index'))
      }
    }
    menu.meta = { title: menu.name, icon: menu.icon }
    if (menu.children && menu.children.length > 0) {
      toRouter(menu.children, menu.path.replace('/', ''))
    }
  }
  // return menus
}
